"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_meta_1 = __importDefault(require("@tencent/odc-meta"));
var odc_meta_content_1 = __importDefault(require("@tencent/odc-meta-content"));
var MetaTabsButtonGroup_1 = __importDefault(require("./MetaTabsButtonGroup"));
var util_1 = require("./util");
var MetaTabs = function MetaTabs(props) {
  var _a = props.type,
    type = _a === void 0 ? 'button' : _a,
    data = props.data,
    foldData = props.foldData,
    foldButtonHottag = props.foldButtonHottag,
    _b = props.expandClassName,
    expandClassName = _b === void 0 ? 'meta-tabs-body' : _b,
    alignment = props.alignment,
    Label = props.Label,
    // eslint-disable-line
    label = props.label,
    // eslint-disable-line
    children = props.children,
    value = props.value,
    onChange = props.onChange,
    _c = props.disabled,
    disabled = _c === void 0 ? false : _c,
    CommonComponent = props.CommonComponent,
    // eslint-disable-line
    _d = props.multiple,
    // eslint-disable-line
    multiple = _d === void 0 ? false : _d,
    addons = props.addons,
    buttonGroupChildren = props.buttonGroupChildren,
    _e = props.showButtonGroup,
    showButtonGroup = _e === void 0 ? true : _e,
    _f = props.MetaContentWrapper,
    MetaContentWrapper = _f === void 0 ? null : _f,
    // eslint-disable-line
    id = props.id,
    _g = props.error,
    error = _g === void 0 ? '' : _g,
    _h = props.warn,
    warn = _h === void 0 ? '' : _h,
    expandStyle = props.expandStyle,
    _j = props.buttonHottagPrefix,
    buttonHottagPrefix = _j === void 0 ? '' : _j,
    prefixCommon = props.prefixCommon,
    _k = props.show,
    show = _k === void 0 ? true : _k,
    _l = props.useTipTarget,
    useTipTarget = _l === void 0 ? false : _l,
    metaProps = props.metaProps,
    tabWarnsCommon = props.tabWarnsCommon,
    MetaTabsNavClassName = props.MetaTabsNavClassName,
    // eslint-disable-line
    ExpandComponent = props.ExpandComponent,
    // eslint-disable-line
    MetaTabsHeadClassName = props.MetaTabsHeadClassName;
  if (!Array.isArray(data) || data.length === 0 || !show) {
    return null;
  }
  var hasActive = false;
  var childrenWithProps = react_1["default"].Children.map(children, function (child) {
    var selected = !multiple ? value !== null && (value === child.props.name || value === child.props['data-name']) : value.indexOf(child.props.name) > -1 || value.indexOf(child.props['data-name']) > -1;
    var newChild = selected ? react_1["default"].cloneElement(child, {
      className: (0, classnames_1["default"])('meta-tabs-panel', child.props.className, {
        active: selected
      })
    }) : null;
    if (selected) {
      hasActive = true;
    }
    return newChild;
  });
  // 如果有按钮hottag前缀的话，可以帮忙转下data加上hottag，这样就不需要特意在外面对data进行遍历了
  var buttonGroupData = [];
  if (showButtonGroup && buttonHottagPrefix) {
    data.forEach(function (item) {
      if (item) {
        buttonGroupData.push(__assign(__assign({
          'data-hottag': "".concat(buttonHottagPrefix, ".").concat(item === null || item === void 0 ? void 0 : item.value)
        }, (0, util_1.getButtonTipTargetProps)(item, useTipTarget)), item));
      }
    });
  } else {
    data.forEach(function (item) {
      if (item) {
        buttonGroupData.push(__assign(__assign({}, (0, util_1.getButtonTipTargetProps)(item, useTipTarget)), item));
      }
    });
  }
  var metaContent;
  if (showButtonGroup || addons) {
    metaContent = react_1["default"].createElement(odc_meta_content_1["default"], {
      className: (0, classnames_1["default"])('meta-tabs-head', MetaTabsHeadClassName)
    }, react_1["default"].createElement(MetaTabsButtonGroup_1["default"], {
      show: showButtonGroup,
      className: (0, classnames_1["default"])('primary-button-group meta-tabs-nav', {
        error: error
      }, MetaTabsNavClassName),
      data: buttonGroupData,
      foldData: foldData,
      foldButtonHottag: foldButtonHottag,
      value: value,
      onChange: onChange,
      disabled: disabled,
      multiple: multiple,
      type: type
    }, buttonGroupChildren), addons);
  }
  return react_1["default"].createElement(odc_meta_1["default"], __assign({
    id: id,
    type: 'tabs'
  }, metaProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])({
      'has-error': error,
      'has-warning': !error && warn,
      'has-radio-group': type === 'radio'
    }),
    supportAllEvents: true
  }, MetaTabs), {
    alignment: alignment,
    ExpandComponent: react_1["default"].createElement(react_1["default"].Fragment, null, hasActive && prefixCommon, tabWarnsCommon, childrenWithProps, error ? react_1["default"].createElement("div", {
      className: "help-block"
    }, error) : null, !error && warn ? react_1["default"].createElement("div", {
      className: "help-block"
    }, warn) : null, hasActive && CommonComponent, ExpandComponent && ExpandComponent),
    expandClassName: (0, classnames_1["default"])('meta-tabs-body', expandClassName, {
      'has-active': hasActive
    }),
    expandStyle: expandStyle
  }), Label || label, MetaContentWrapper !== null ? react_1["default"].createElement(MetaContentWrapper, null, metaContent) : metaContent);
};
(0, spaui_utils_1.setComponentMark)(MetaTabs, info_1["default"]);
exports["default"] = react_1["default"].memo(MetaTabs);